/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KpiParameterSchema } from './kpi-parameter-schema';
import { KpiStatus } from './kpi-status';
import { FilterBindingSchema } from './filter-binding-schema';
import { TrendTileSettingsSchema } from './trend-tile-settings-schema';
import { TileLocalizedTitleDto } from './tile-localized-title-dto';


export interface DashboardResolvedItemDto { 
    _id: string;
    /**
     * Dashboard definition this item belongs to.
     */
    dashboardId: string;
    /**
     * Published KPI definition rendered by this dashboard item.
     */
    kpiId: string;
    /**
     * Pin to a specific version. When null, the KPI\'s published version is served.
     */
    kpiVersionId?: string;
    /**
     * Freeform tile layout state owned by the UI.
     */
    layout?: { [key: string]: any; };
    /**
     * Sort order for this item within the dashboard.
     */
    order: number;
    /**
     * Optional display title for this dashboard item, in English; falls back to the localized KPI title.
     */
    titleOverride?: string;
    /**
     * The tile\'s title override in languages other than English, keyed by two-letter lowercase language code, at most 20 languages, for example {\"de\": {\"titleOverride\": \"Neue Mitglieder\"}, \"cs\": {\"titleOverride\": \"Noví členové\"}}. English goes in the plain titleOverride; an en key is rejected. A client shows the entry for the viewer\'s language, else the plain titleOverride. With neither, the tile shows the KPI title in the viewer\'s language. Null when there are no translations.
     */
    i18n?: { [key: string]: TileLocalizedTitleDto; } | null;
    status: DashboardResolvedItemDto.StatusEnum;
    /**
     * Connections from dashboard filters to this tile\'s KPI parameters: at most one per filter and one per parameter, each of a compatible type.
     */
    filterBindings: Array<FilterBindingSchema>;
    /**
     * Trend tiles only: what the tile compares with. Absent means [previous_period]. Ignored on tiles of other KPI types.
     */
    trend?: TrendTileSettingsSchema | null;
    /**
     * KPI version that will be served for this tile after resolving pinned or published version.
     */
    resolvedVersionId?: string | null;
    /**
     * Parameters declared on the served KPI version. These are the targets a dashboard filter can bind to for this tile.
     */
    parameters: Array<KpiParameterSchema>;
    /**
     * Non-fatal configuration warnings for this item.
     */
    warnings: Array<string>;
    /**
     * Lifecycle status of the KPI behind this tile. A tile whose KPI is archived stays on the board but renders no data until the KPI is restored. Null when the tile points at a KPI this program no longer has.
     */
    kpiStatus: KpiStatus | null;
}
export namespace DashboardResolvedItemDto {
    export const StatusEnum = {
        Visible: 'visible',
        Hidden: 'hidden'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


